<template>
  <article class="recruitment-wrapper">
    <div class="container">
      <p class="text0">인재채용</p>
      <p class="text1">
        CARROT은 최고의 인재들과 최고의 일터를 만들어 나가고 있습니다.<br />끊임없이
        도전하는 열정과 재능을 겸비한 모든 사람에게 언제나 열려있습니다.
      </p>
      <div class="go-support">
        <p @click="goPage">지원하러가기</p>
        <img
          src="@/assets/img/newGlobal/introduce/main/recruitment/arrow.png"
          alt="icon"
        />
      </div>
    </div>
  </article>
</template>
<script>
export default {
  methods: {
    goPage() {
      this.$router.push({ path: "/Recruit" });
    },
  },
};
</script>
<style lang="scss" scoped>
.recruitment-wrapper {
  padding: 40px 0;
  background: url(~@/assets/img/newGlobal/introduce/main/recruitment/bg.png)
    no-repeat center / cover fixed;
  color: #ffffff;
  text-align: center;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .text0 {
    font-size: 33px;
    font-weight: 700;
    margin-bottom: 26px;

    @media screen and (min-width: 1350px) {
      font-size: 50px;
      margin-bottom: 52px;
    }
  }

  .text1 {
    font-size: 18px;
    margin-bottom: 90px;

    @media screen and (min-width: 1350px) {
      font-size: 22px;
      margin-bottom: 80px;
    }
  }

  .go-support {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    > p {
      @media screen and (min-width: 1350px) {
        font-size: 20px;
      }
    }
  }
}
</style>
